import type { ToastStateObj } from '../types/toast';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useToastStore = defineStore('toast', () => {
    const toastStateData = ref<ToastStateObj | null>(null);

    const setToast = (messageObj: ToastStateObj) => {
        toastStateData.value = {
            ...messageObj,
        };
    };

    const clearToast = () => {
        toastStateData.value = null;
    };

    return {
        toastStateData,
        setToast,
        clearToast,
    };
});

export default useToastStore;
